const getEnv = key => {
  if (
    typeof window !== 'undefined' &&
    window.__APP_ENV__ &&
    window.__APP_ENV__[key] !== undefined
  ) {
    return window.__APP_ENV__[key];
  }
  return process.env[key];
};

export const env = {
  url_prd: getEnv('REACT_APP_URL_PRD'),
};
